export class UserRejectedError extends Error {
  // Reject code from EIP-1193
  public static readonly USER_REJECTED_CODE = 4001
  // Reject code from EIP-3085
  public static readonly ACTION_REJECTED_CODE = 'ACTION_REJECTED'

  public code = UserRejectedError.USER_REJECTED_CODE
  constructor(message: string) {
    super(message)
    this.name = 'UserRejectedError'
  }

  /**
   * Check if the given error is a UserRejectedError.
   * @param error The error to check.
   * @returns True if the error is a UserRejectedError, otherwise false.
   */
  static is(error: Error | UserRejectedError | any): boolean {
    return (
      error instanceof UserRejectedError ||
      error?.code === UserRejectedError.USER_REJECTED_CODE ||
      error?.code === UserRejectedError.ACTION_REJECTED_CODE ||
      // For redux/toolkit, the error will be refactored to a standard error object
      // However, the error name will be remained, we can check the error name to determine
      error?.name === 'UserRejectedError'
    )
  }
}
